// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__168Tr","header":"PatientQuestionnaire_header__1Dg2t","info":"PatientQuestionnaire_info__3OKK5"};